import { render, staticRenderFns } from "./emailsRecipients.vue?vue&type=template&id=19235a50&lang=pug"
import script from "./emailsRecipients.vue?vue&type=script&lang=js"
export * from "./emailsRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports